{
 "_meta": {
  "locale": "ar",
  "status": "partial",
  "note": "Shell translation (draft, needs native review). Missing keys fall back to English."
 },
 "nav": {
  "today": "الآن",
  "people": "الأشخاص",
  "cases": "الملفات",
  "agenda": "المفكرة",
  "reviews": "المراجعات",
  "prospects": "استقطاب العملاء",
  "insights": "التحليلات",
  "data": "البيانات والأمان",
  "settings": "الإعدادات",
  "lens": "العدسة"
 },
 "common": {
  "save": "حفظ",
  "cancel": "إلغاء",
  "close": "إغلاق",
  "search": "بحث",
  "today": "اليوم",
  "tomorrow": "غدًا",
  "new": "جديد",
  "edit": "تعديل",
  "delete": "حذف"
 },
 "settings": {
  "title": "الإعدادات",
  "language": "اللغة",
  "region": "السوق / المنطقة",
  "theme": "المظهر"
 },
 "people": {
  "title": "الأشخاص",
  "new": "شخص جديد"
 },
 "today": {
  "agenda_title": "اليوم"
 },
 "lens": {
  "placeholder": "ابحث عن أشخاص أو عملاء محتملين أو ملفات — أو اكتب أمرًا"
 }
}